// extracted by mini-css-extract-plugin
export default {"required":"YoLabel_required__j4kBu"};